uniform float uTime;
uniform float uAspect;
uniform vec2 uLightPosition;
uniform float uRayCount;
uniform float uRaySpeed;

// control these with dat.gui:
uniform float uLargeVariation; // default 1.0 (range (0, 2))
uniform vec3 lightColor; // default  vec3(1.0, 0.9, 0.7);
uniform float uGammaBorder; // default 1.0 (range (0, 4))
uniform float uLightIntensity;
uniform vec2 uUVScale; // control UV scaling

// end control

varying vec2 vUv;

// Hash function for pseudo-random numbers
float hash21_shine(vec2 p) {
    p = fract(p * vec2(234.34, 435.345));
    p += dot(p, p + 34.23);
    return fract(p.x * p.y);
}

// 2D Noise
float noise_shine(vec2 p) {
    vec2 i = floor(p);
    vec2 f = fract(p);
    
    float a = hash21_shine(i);
    float b = hash21_shine(i + vec2(1.0, 0.0));
    float c = hash21_shine(i + vec2(0.0, 1.0));
    float d = hash21_shine(i + vec2(1.0, 1.0));
    
    vec2 u = f * f * (3.0 - 2.0 * f);
    return mix(a, b, u.x) + (c - a)* u.y * (1.0 - u.x) + (d - b) * u.x * u.y;
}

// FBM (Fractional Brownian Motion)
float fbm_shine(vec2 p, float frequency) {
    float value = 0.0;
    float amplitude = 1.0;
    // float frequency = 0.7;
    float total = amplitude;
    for(int i = 0; i < 4; i++) {
        value += amplitude * noise_shine(p * frequency);
        frequency *= 2.0;
        amplitude *= 0.5;
        total += amplitude;
    }
    return value / total;
}

// Function to create a radial ray pattern
float rays(vec2 uv, vec2 lightPos, float count, float time, float freq) {
    vec2 toLight = uv - lightPos;
    float angle = atan(toLight.y, toLight.x);
    float dist = length(toLight);
    
    // Create periodic noise coordinates
    float noiseScale = 5.0;
    vec2 noiseCoord = vec2(
        cos(angle) * noiseScale + time * 0.2,
        sin(angle) * noiseScale + time * 0.1
    );
    float variation = pow(fbm_shine(noiseCoord, freq), 2.0) * 2.0;
    
    // Combine noise with base ray pattern
    float rayLength = 0.75 + variation * 0.25;
    float rays = abs(sin(angle * count + -time * uRaySpeed + variation * 5.0));
    
    float falloff = max(0.0, 1.0 - dist/0.5);// - dist / 0.25 ;//pow(1.0 - smoothstep(0.0, 0.5 - (1.0 - rayLength) * 0.5, dist), 1.0)*1.0;
    return variation * falloff;// * (0.8 + rays * 0.2);
}
vec3 hsv2rgb(vec3 c) {
    vec4 K = vec4(1.0, 2.0/3.0, 1.0/3.0, 3.0);
    vec3 p = abs(fract(c.xxx + K.xyz) * 6.0 - K.www);
    return c.z * mix(K.xxx, clamp(p - K.xxx, 0.0, 1.0), c.y);
}

void main() {
    vec2 uv = vUv;
    // Scale UV based on width and height controls
    uv = (uv - 0.5) * uUVScale + 0.5;
    
    // Create animated rays
    float ray = rays(uv, uLightPosition, uRayCount, uTime*1.0, 0.5);
    float ray2 = rays(uv, uLightPosition, uRayCount, uTime*2.0, 0.4);
    
    ray *= (1.0-uLargeVariation) + ray2*3.0*uLargeVariation;
    // Create a soft glow around the light source
    // float dist = length(vUv - uLightPosition);
    float glow = 1.0 - pow(smoothstep(0.0, 0.5, length(vUv - uLightPosition)), 0.1);
    
    // Combine rays and glow
    float shine = ray * uLightIntensity + glow;
    shine += pow(max(0.0, 0.15 - length(vUv - uLightPosition)) / 0.15, 3.0) * 1.0;
    // shine *= 1.0-pow(max(0.0, length(vUv - uLightPosition)), 2.);
    // shine = min(1.0, max(0.0, shine));
    // Create warm light color
    // vec3 lightColor = vec3(1.0, 0.9, 0.7);
    float dist = pow(max(0.0, 0.5 - length(vUv - vec2(0.5, 0.5))), 4.0);
    vec3 rainbow = hsv2rgb(vec3(dist*5.0 + uTime, 0.2, 1.0));
    vec3 finalColor = lightColor;//rainbow* (dist + shine);
    // vec3 finalColor = vec3(0.0, 0.0, 0.0) + lightColor* shine;
    finalColor = max(vec3(0.0), min(vec3(1.0), finalColor));
    gl_FragColor = vec4(lightColor, max(0.0, min(1.0, shine * uLightIntensity)));
    // gl_FragColor = vec4(1.0,0.0,0.0,1.0);
}
